exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "pre[class*=language-]{margin:0}code{display:block;font-size:1.5em}", "", {"version":3,"sources":["/home/travis/build/gndplayground/styled-components-presentation/src/index.css"],"names":[],"mappings":"AAAA,sBACI,QAAU,CACb,AAED,KACI,cAAe,AACf,eAAiB,CACpB","file":"index.css","sourcesContent":["pre[class*=\"language-\"] {\n    margin: 0;\n}\n\ncode {\n    display: block;\n    font-size: 1.5em;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/postcss-loader/lib!./src/index.css
// module id = 536
// module chunks = 73